import { SchedulingErrorCode } from '../helpers/ErrorCodes';
import { L10n } from '../L10n/L10n';
import { IErrorItem } from '../models/MultipleItemResult';
import { Module } from '../Module';
import { IError } from '../ServerApi/types/IError';
import { ISchedule } from '../ServerApi/types/ISchedule';
import { IErrorDetail } from './ContentActionNotification';
import { SchedulesConfig } from './SchedulesConfig';
import { ServerService } from './ServerService';

export class ScheduleErrors {

  public static $inject = ['ServerService', 'SchedulesConfig', '$translate'];

  constructor(
    private ServerService: ServerService,
    private SchedulesConfig: SchedulesConfig,
    private $translate: ng.translate.ITranslateService) { }

  public errorDetailsFor(scheduleErrorItem: IErrorItem<ISchedule>): IErrorDetail {
    return {
      itemName: scheduleErrorItem.item.name,
      itemUrl:
        scheduleErrorItem.error.code === SchedulingErrorCode.SchedulingScheduleNotFound
          ? null
          : this.scheduleUrl(scheduleErrorItem.item),
      errorMessage: this.errorMessageForItem(scheduleErrorItem)
    };
  }

  private scheduleUrl(schedule: ISchedule): string {
    return this.ServerService.sessionSiteId()
      ? this.SchedulesConfig.siteUrlFor(schedule)
      : this.SchedulesConfig.serverUrlFor(schedule);
  }

  private errorMessageForItem(errorItem: IErrorItem<ISchedule>) {
    return this.errorMessageFor(errorItem.error, errorItem.item.name);
  }

  public errorMessageFor(error: IError, scheduleName: string = '') {

    switch (error.code) {
      case SchedulingErrorCode.SchedulingScheduleNotFound:
        return this.$translate.instant('errorScheduleNotFound', { SCHEDULE_NAME: L10n.elideIfLong(scheduleName) });
      case SchedulingErrorCode.SchedulingNameAlreadyExists:
        return this.$translate.instant('errorScheduleNameAlreadyExists');
      case SchedulingErrorCode.SchedulingNameTooLong:
        return this.$translate.instant('errorScheduleNameTooLong');
      default:
        return this.$translate.instant('errorUnknown');
    }
  }

}

Module.instance().service('ScheduleErrors', ScheduleErrors);
